<template>
	<form class="card-form">
		<h5
			class="font-weight-bold d-flex align-items-center justify-content-between flex-nowrap"
		>
			Card info
			<span class="payment-icons">
				<span class="icon-visa mr-2"></span>
				<span class="icon-mastercard mr-2"></span>
				<span class="icon-express mr-2"></span>
				<span class="icon-jcb mr-2"></span>
				<span class="icon-discover mr-2"></span>
				<span class="icon-diners"></span>
			</span>
		</h5>
		<div class="form-group">
			<label for="name">Name on card</label>
			<input
				type="text"
				class="form-control"
				id="name"
				v-model="card.name"
				placeholder="Name"
				required
				:class="{ 'is-invalid': invalid.name }"
			/>
		</div>
		<div class="form-group position-relative">
			<label for="number">Card</label>
			<div class="form-group" id="stripe-card-element"></div>
			<span class="text-danger" v-if="stripeError">{{
				stripeError
			}}</span>
		</div>
	</form>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PK } from "../../../config/config";

export default {
	name: "CardForm",
	data() {
		return {
			card: {
				name: "",
			},
			expDate: "",
			cardIcon: null,
			invalid: {
				name: false,
			},
			stripePubKey: STRIPE_PK,
			stripe: null,
			stripeEl: "",
			stripeCard: "",
			stripeError: "",
		};
	},
	mounted() {
		this.getStripe();
	},
	methods: {
		getCard() {
			let isValid = this.validateForm();
			if (isValid && this.stripeError.length === 0) {
				return this.stripe
					.createToken(this.stripeCard)
					.then((result) => {
						if (result.error) {
							this.stripeError = result.error.message;
							return null;
						} else {
							return {
								token: result.token,
								name: this.card.name,
							};
						}
					});
			} else {
				return Promise.resolve(null);
			}
		},
		validateForm() {
			return this.validateName();
		},
		validateName() {
			if (!this.card.name) {
				this.invalid.name = true;
				return false;
			}
			this.invalid.name = false;
			return true;
		},
		getStripe() {
			loadStripe(this.stripePubKey)
				.then((result) => {
					this.stripe = result;
					this.configureStripe();
				})
				.catch((err) => {
					this.$refs.errDialog = err;
				});
		},
		configureStripe() {
			let style = {
				base: {
					color: "#495057",
					fontFamily: '"Lato", sans-serif',
					fontSmoothing: "antialiased",
					fontSize: "14px",
					"::placeholder": {
						color: "#7a7a7a",
					},
				},
			};

			this.stripeEl = this.stripe.elements();
			this.stripeCard = this.stripeEl.create("card", { style });

			this.stripeCard.mount("#stripe-card-element");

			this.stripeCard.on("change", (event) => {
				if (event.error) {
					this.stripeError = event.error.message;
				} else {
					this.stripeError = "";
				}
			});
		},
	},
	destroyed() {
		if(this.stripeCard) {
			this.stripeCard.destroy();
		}
	}
};
</script>

<style>
.icon-card-back {
	display: inline-block;
	height: 21px;
	width: 28px;
	background-image: url("../../assets/icons/payment/card-back.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	bottom: 8px;
	left: 10px;
}
.icon-calendar {
	display: inline-block;
	height: 22px;
	width: 22px;
	background-image: url("../../assets/icons/payment/calendar.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	bottom: 8px;
	left: 10px;
}
.icon-card-front {
	display: inline-block;
	height: 21px;
	width: 28px;
	background-image: url("../../assets/icons/payment/card-front.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	bottom: 8px;
	left: 5px;
}
.icon-card-detect {
	display: inline-block;
	height: 21px;
	width: 28px;
	bottom: 4px;
	right: 5px;
}
.padding-left-5 {
	padding-left: 3.7rem;
}
.padding-left-4 {
	padding-left: 3rem;
}
.payment-icons {
	height: 28px;
	white-space: pre;
}
.icon-visa {
	background-image: url("../../assets/icons/payment/visa.svg");
}
.icon-mastercard {
	background-image: url("../../assets/icons/payment/mastercard.svg");
}
.icon-express {
	background-image: url("../../assets/icons/payment/americanexpress.svg");
}
.icon-discover {
	background-image: url("../../assets/icons/payment/discover.svg");
}
.icon-diners {
	background-image: url("../../assets/icons/payment/diners.svg");
}
.icon-jcb {
	background-image: url("../../assets/icons/payment/jcb.svg");
}
.icon-visa,
.icon-mastercard,
.icon-express,
.icon-discover,
.icon-diners,
.icon-jcb {
	display: inline-block;
	height: 28px;
	width: 42px;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
}
.StripeElement {
	box-sizing: border-box;

	height: 37px;

	padding: 9px 12px;

	border: 1px solid transparent;
	border-radius: 4px;
	background-color: white;

	border: 1px solid #262830;
	-webkit-transition: box-shadow 150ms ease;
	transition: box-shadow 150ms ease;
}

.StripeElement--focus {
	-webkit-box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2),
		inset 0px 0px 0px rgba(0, 0, 0, 0);
	box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2),
		inset 0px 0px 0px rgba(0, 0, 0, 0);
}

.StripeElement--invalid {
	border-color: #fa755a;
}

.StripeElement--webkit-autofill {
	background-color: #fefde5 !important;
}
</style>